/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedBookingsIndexRouteImport } from './routes/_authenticated/bookings/index'
import { Route as AuthenticatedCallsHistoryRouteImport } from './routes/_authenticated/calls/history'
import { Route as AuthenticatedBookingsBookingIdRouteImport } from './routes/_authenticated/bookings/$bookingId'
import { Route as AuthenticatedAdminUsersIndexRouteImport } from './routes/_authenticated/admin/users/index'
import { Route as AuthenticatedAdminAuditIndexRouteImport } from './routes/_authenticated/admin/audit/index'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBookingsIndexRoute =
  AuthenticatedBookingsIndexRouteImport.update({
    id: '/bookings/',
    path: '/bookings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallsHistoryRoute =
  AuthenticatedCallsHistoryRouteImport.update({
    id: '/calls/history',
    path: '/calls/history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBookingsBookingIdRoute =
  AuthenticatedBookingsBookingIdRouteImport.update({
    id: '/bookings/$bookingId',
    path: '/bookings/$bookingId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminUsersIndexRoute =
  AuthenticatedAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAuditIndexRoute =
  AuthenticatedAdminAuditIndexRouteImport.update({
    id: '/audit/',
    path: '/audit/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/bookings/$bookingId': typeof AuthenticatedBookingsBookingIdRoute
  '/calls/history': typeof AuthenticatedCallsHistoryRoute
  '/bookings/': typeof AuthenticatedBookingsIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/admin/audit/': typeof AuthenticatedAdminAuditIndexRoute
  '/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/bookings/$bookingId': typeof AuthenticatedBookingsBookingIdRoute
  '/calls/history': typeof AuthenticatedCallsHistoryRoute
  '/bookings': typeof AuthenticatedBookingsIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/admin/audit': typeof AuthenticatedAdminAuditIndexRoute
  '/admin/users': typeof AuthenticatedAdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/bookings/$bookingId': typeof AuthenticatedBookingsBookingIdRoute
  '/_authenticated/calls/history': typeof AuthenticatedCallsHistoryRoute
  '/_authenticated/bookings/': typeof AuthenticatedBookingsIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/admin/audit/': typeof AuthenticatedAdminAuditIndexRoute
  '/_authenticated/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/unauthorized'
    | '/admin'
    | '/bookings/$bookingId'
    | '/calls/history'
    | '/bookings/'
    | '/dashboard/'
    | '/admin/audit/'
    | '/admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/unauthorized'
    | '/admin'
    | '/bookings/$bookingId'
    | '/calls/history'
    | '/bookings'
    | '/dashboard'
    | '/admin/audit'
    | '/admin/users'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/unauthorized'
    | '/_authenticated/admin'
    | '/_authenticated/bookings/$bookingId'
    | '/_authenticated/calls/history'
    | '/_authenticated/bookings/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/admin/audit/'
    | '/_authenticated/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bookings/': {
      id: '/_authenticated/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof AuthenticatedBookingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calls/history': {
      id: '/_authenticated/calls/history'
      path: '/calls/history'
      fullPath: '/calls/history'
      preLoaderRoute: typeof AuthenticatedCallsHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bookings/$bookingId': {
      id: '/_authenticated/bookings/$bookingId'
      path: '/bookings/$bookingId'
      fullPath: '/bookings/$bookingId'
      preLoaderRoute: typeof AuthenticatedBookingsBookingIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/users/': {
      id: '/_authenticated/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthenticatedAdminUsersIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/audit/': {
      id: '/_authenticated/admin/audit/'
      path: '/audit'
      fullPath: '/admin/audit/'
      preLoaderRoute: typeof AuthenticatedAdminAuditIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAuditIndexRoute: typeof AuthenticatedAdminAuditIndexRoute
  AuthenticatedAdminUsersIndexRoute: typeof AuthenticatedAdminUsersIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAuditIndexRoute: AuthenticatedAdminAuditIndexRoute,
  AuthenticatedAdminUsersIndexRoute: AuthenticatedAdminUsersIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedBookingsBookingIdRoute: typeof AuthenticatedBookingsBookingIdRoute
  AuthenticatedCallsHistoryRoute: typeof AuthenticatedCallsHistoryRoute
  AuthenticatedBookingsIndexRoute: typeof AuthenticatedBookingsIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedBookingsBookingIdRoute: AuthenticatedBookingsBookingIdRoute,
  AuthenticatedCallsHistoryRoute: AuthenticatedCallsHistoryRoute,
  AuthenticatedBookingsIndexRoute: AuthenticatedBookingsIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
